import api from "@modules/api/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import purchaseQueryKeys from "@modules/purchase/purchaseQueryKeys";
import { LocalDateTime } from "@js-joda/core";
import dropOffLocationQueryKeys from "@modules/drop-off-location/dropOffLocationQueryKeys";

export type UpdateDropOffLocationRequest = {
  dealId: string;
  appointmentAt: LocalDateTime;
  dropOffLocationId: string;
  locale: string;
};

type ResponseBody = {
  isAppointmentUnavailable: boolean;
};

const putUpdateDropOffLocationAppointmentDate = async (
  updateDropOffLocationRequest: UpdateDropOffLocationRequest
): Promise<ResponseBody> => {
  return api.put<ResponseBody>(
    `api/purchases/${updateDropOffLocationRequest.dealId}/drop-off-location-appointment-at`,
    {
      json: updateDropOffLocationRequest,
      headers: { "Accept-Language": updateDropOffLocationRequest.locale },
    }
  );
};

export default function useUpdatePurchaseDropOffLocationAppointmentDateMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: putUpdateDropOffLocationAppointmentDate,
    onSuccess: (_, { dealId }) => {
      queryClient.invalidateQueries({
        queryKey: purchaseQueryKeys.purchases([dealId]),
      });
      queryClient.invalidateQueries({
        queryKey: purchaseQueryKeys.dealTodos(dealId),
      });
      queryClient.invalidateQueries({ queryKey: dropOffLocationQueryKeys.all });
    },
  });
}
